// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"f6-z","button":"g6-z","disabled":"h6-z","creditCard":"i6-z","wrapper":"j6-z"};